import React, { useEffect, useReducer, useState } from "react";
import * as actions from "../../../actions/dle";
import dleReducer from "../../../reducers/dle";
import moment from "moment";
import ColumnChart from "./ColumnChart";
import { useSelector } from "react-redux";
import { RadioGroup, SelectBox } from "devextreme-react";
import { NumberBox } from "devextreme-react/number-box";

const initialState = { dleMissReasonParetoData: null };
const DLEParetoChart = (props: any) => {
  const [state, dispatch] = useReducer(dleReducer, initialState);
  let { dleMissReasonParetoData } = state;
  const [sDate, setSDate] = useState(new Date());
  const [eDate, setEDate] = useState(new Date());
  const [duration, setDuration] = useState(60);
  const [animate, setAnimate] = useState("");
  const [reasonLevel, setReasonLevel] = useState(0);
  const [isCascaded, setIsCascaded] = useState(true);
  const [numberOfReasons, setNumberOfReasons] = useState(15);
  const isLightMode = useSelector((state: any) => state.theme.lightMode);

  useEffect(() => {
    setTimeout(() => {
      setAnimate("animate");
    }, 250);
  }, []);

  useEffect(() => {
    if (props.tierId) {
      const date = sDate;
      let newDate = date.setDate(date.getDate() - duration);

      let clsDLEGraphRequest = {
        dleId: 1002,
        startDate: moment(newDate).format("YYYY-MM-DD"),
        toDate: moment(eDate).format("YYYY-MM-DD"),
        tierId: props.tierId,
        reasonLevel,
        rowCount: numberOfReasons,
        isCascaded: String(isCascaded),
      };
      actions.getDLEMissReasonParetoData(dispatch, clsDLEGraphRequest);
      setSDate(new Date());
    }
  }, [props.showDInput, reasonLevel, numberOfReasons, isCascaded]);

  return (
    <section className="page-content">
      <div className="site-view tier-wrap admin-console-wrapper">
        <div
          className={"site-list " + animate}
          style={{
            backgroundColor: isLightMode ? "#d3d3d3" : "#2f3030",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <div
              style={{
                marginRight: "10px",
              }}
            >
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                Number of Reasons
              </span>
              <NumberBox
                min={1}
                width={168}
                step={5}
                showSpinButtons={true}
                value={numberOfReasons}
                onValueChanged={(e) => {
                  {
                    if (e.value > 0) {
                      setNumberOfReasons(e.value);
                    }
                  }
                }}
              />
            </div>
            <div>
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                Select Level
              </span>
              <SelectBox
                dataSource={[
                  {
                    label: "Level 0",
                    value: 0,
                  },
                  {
                    label: "Level 1",
                    value: 1,
                  },
                  {
                    label: "Level 2",
                    value: 2,
                  },
                ]}
                displayExpr="label"
                valueExpr="value"
                wrapItemText={true}
                onValueChanged={(e) => {
                  setReasonLevel(e.value);
                }}
                value={reasonLevel}
                width={200}
              />
            </div>
            <div
              style={{
                marginLeft: "10px",
              }}
            >
              <span
                style={{
                  fontSize: "12px",
                }}
              >
                Level Drilldown
              </span>
              <RadioGroup
                hint="Level Drilldown"
                items={[
                  { value: true, label: "Yes" },
                  { value: false, label: "No" },
                ]}
                valueExpr="value"
                displayExpr="label"
                onValueChanged={(e) => {
                  setIsCascaded(e.value);
                }}
                layout="horizontal"
                value={isCascaded}
                style={{
                  marginTop: "10px",
                }}
              />
            </div>
          </div>
          {dleMissReasonParetoData && (
            <ColumnChart
              dleMissReasonParetoData={dleMissReasonParetoData}
              tierId={props.tierId}
            ></ColumnChart>
          )}
        </div>
      </div>
    </section>
  );
};
export default DLEParetoChart;
